export const bodyOveflow = (isOpen) => {
	document.body.style.overflow = `${!isOpen ? "hidden" : ""}`;
};
